import { Key } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const KeyIcon = createLucideIcon(Key);
